import { useState, useEffect } from 'react'
import { throttle } from 'lodash'
import { isPC as isPCFn } from '@/utils'

export function usePC() {
  const [isPC, setIsPC] = useState(true)

  const resolveClient = () => {
    setIsPC(isPCFn())
  }
  const handleTransform = throttle(() => {
    resolveClient()
  }, 500)
  useEffect(() => {
    resolveClient()
    window.addEventListener('resize', handleTransform, true)
    return () => {
      window.removeEventListener('resize', handleTransform, true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    isPC,
  }
}
